export const messages = {
  ourClients: "Our Clients",
};
